import React from 'react'

export default function SaaSDesign() {
  return (
    <div>
    <section className="bg-black text-center py-20 px-4">
        <h1 className="text-4xl font-bold">SaaS UI UX Design Agency</h1>
        <p className="mt-4 text-lg">Is your SaaS churn rate sky-high? Users leave for poor design and sluggish performance. Turn traffic into SaaS subscribers with our data-driven design revamp.</p>
        <button className="mt-6 px-6 py-2 bg-yellow-400 text-black font-bold rounded-full">Build Your SaaS Product Now</button>
    </section>
    <section className="bg-white text-black py-20 px-4">
        <div className="container mx-auto flex flex-col md:flex-row items-center">
            <div className="md:w-1/2">
                <img src="https://placehold.co/600x400" alt="Person working on a laptop with graphs and charts on the screen" className="w-full rounded-lg shadow-lg"/>
            </div>
            <div className="md:w-1/2 md:pl-10 mt-10 md:mt-0">
                <h2 className="text-3xl font-bold">Don’t be part of the crowd that fails—craft your SaaS success story with us!</h2>
                <p className="mt-4 text-lg">Many SaaS businesses fail because of outdated UI and poor user experience, costing them valuable customers. We design interfaces grounded in audience research, ensuring your business stands out and thrives.</p>
                <button className="mt-6 px-6 py-2 bg-yellow-400 text-black font-bold rounded-full">FREE SaaS audit!</button>
            </div>
        </div>
    </section>
    <section className="bg-black text-white py-20 px-4">
        <div className="container mx-auto flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 md:pr-10">
                <h2 className="text-3xl font-bold">Build a loyal user base with flawless, conversion-focused saas experiences!</h2>
                <p className="mt-4 text-lg">A great user experience is the key to bringing back visitors to your SaaS business. More returning customers mean more revenue and growth. This happens when you address the right pain points and present them in the most user-friendly way possible.</p>
                <button className="mt-6 px-6 py-2 bg-yellow-400 text-black font-bold rounded-full">Reserve your Seat!</button>
            </div>
            <div className="md:w-1/2 mt-10 md:mt-0">
                <img src="https://placehold.co/600x400" alt="Laptop displaying analytics dashboard" className="w-full rounded-lg shadow-lg"/>
            </div>
        </div>
    </section>
    <section className="bg-gray-100 text-black py-20 px-4">
        <div className="container mx-auto text-center">
            <h2 className="text-3xl font-bold">How do we pave your success path in the SaaS business?</h2>
            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-10">
                <div className="bg-white p-6 rounded-lg shadow-lg">
                    <img src="https://placehold.co/300x200" alt="Illustration of a person analyzing data" className="w-full rounded-lg"/>
                    <h3 className="mt-4 text-xl font-bold">Data-Driven Design</h3>
                    <p className="mt-2 text-lg">We use data to inform our design decisions, ensuring that your SaaS product meets the needs of your users.</p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-lg">
                    <img src="https://placehold.co/300x200" alt="Illustration of a team working together" className="w-full rounded-lg"/>
                    <h3 className="mt-4 text-xl font-bold">Collaborative Approach</h3>
                    <p className="mt-2 text-lg">We work closely with your team to understand your business goals and create a design that aligns with them.</p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-lg">
                    <img src="https://placehold.co/300x200" alt="Illustration of a person using a mobile app" className="w-full rounded-lg"/>
                    <h3 className="mt-4 text-xl font-bold">User-Centered Design</h3>
                    <p className="mt-2 text-lg">Our designs are focused on providing the best possible experience for your users, ensuring that they keep coming back.</p>
                </div>
            </div>
        </div>
    </section>
</div>
  )
}
